import styled from 'styled-components/macro'
import { Box, Typography, TextField, Link } from '@material-ui/core'
import { ArrowBackIos } from '@material-ui/icons'
import { Logo } from 'components/page/logo'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useState } from 'react'
import { Button } from 'common/atoms/Button/Button'

const LogoImage = styled.img`
  width: 300px;
`

export const EmailInviteSignUp = () => {
  const theme = useTheme()
  const [selectedPage, setSelectedPage] = useState(0)
  return (
    <Box>
      {selectedPage == 0 && (
        <Box display="flex">
          <Box width="30%">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              bgcolor={theme.colors.supplementary}
              color={theme.colors.accent1}
            >
              <Box pt={3}>
                <Logo size="small" />
              </Box>
              <Box pt={15} width="70%">
                <LogoImage src="https://i.imgur.com/cZgyuQj.jpg" alt="side-panel" />
              </Box>
              <Box pb={15} width="70%">
                <Typography align="center">copy to let members know of what they can do in Obsidi</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            width="60%"
            display="flex"
            flexDirection="column"
            alignItems="left"
            pt={20}
            pl={20}
            bgcolor={theme.colors.bgPrimary}
            color={theme.colors.Primary}
          >
            <Box pb={3} display="flex" flexDirection="column">
              <Typography variant="h4">Welcome to the new</Typography>
              <Typography variant="h4">Obsidi platform, Myron!</Typography>
            </Box>
            <Box pt={2}>
              <Typography component="p">
                Before you can start enjoying all the new benefits packed here, we would like to update your information
                to create the credentials that you will use to login in the future. Lets start with your email, do you
                want to use this email?
              </Typography>
            </Box>
            <Box padding="1em 0">
              <Typography component="p" variant="caption">
                <sup>*</sup>Required fields
              </Typography>
            </Box>
            <Box>
              <Typography component="p">
                Email Address<sup>*</sup>
              </Typography>
            </Box>
            <TextField variant="outlined" />
            <Box display="flex" justifyContent="flex-end" mt="2em">
              <Button design='secondary' onClick={() => setSelectedPage(selectedPage + 1)}>
                Confirm and Continue
              </Button>
            </Box>
          </Box>
        </Box>
      )}
      {selectedPage == 1 && (
        <Box display="flex">
          <Box width="30%">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              bgcolor={theme.colors.supplementary}
              color={theme.colors.accent1}
            >
              <Box pt={3}>
                <Logo size="small" />
              </Box>
              <Box pt={15} width="70%">
                <LogoImage src="https://i.imgur.com/cZgyuQj.jpg" />
              </Box>
              <Box pb={15} width="70%">
                <Typography align="center">copy to let members know of what they can do in Obsidi</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            width="60%"
            display="flex"
            flexDirection="column"
            alignItems="left"
            pt="8em"
            pl={20}
            bgcolor={theme.colors.bgPrimary}
            color={theme.colors.Primary}
          >
            <Box display="flex" pb="3em">
              <Typography component="p">
                <Link onClick={() => setSelectedPage(selectedPage - 1)}>
                  <ArrowBackIos fontSize="small" color={theme.colors.Primary} />
                </Link>
              </Typography>
              <Typography>
                <Link onClick={() => setSelectedPage(selectedPage - 1)}>Back</Link>
              </Typography>
            </Box>
            <Box pb={3}>
              <Typography variant="h4">Create new password</Typography>
            </Box>
            <Box pt="0.5em">
              <Typography component="p">
                Now, let’s create a password for you to use when logging in. Hover on the info icon on the field to
                learn about the password requirements.
              </Typography>
            </Box>
            <Box padding="2em 0 1em 0">
              <Typography component="p" variant="caption">
                <sup>*</sup>Required fields
              </Typography>
            </Box>
            <Box>
              <Typography component="p">
                Enter new password<sup>*</sup>
              </Typography>
            </Box>
            <TextField variant="outlined" />
            <Box pt="1em">
              <Typography component="p">
                Re-enter new password<sup>*</sup>
              </Typography>
            </Box>
            <TextField variant="outlined" />
            <Box display="flex" justifyContent="flex-end" margin="2em 0">
              <Button design='secondary' onClick={() =>{}}>
                Save new password
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
